module.exports = __webpack_public_path__ + "static/media/Me_Syd.081c49be.jpg";